/* eslint-disable no-unused-vars */
import { useCallback, useRef, useEffect } from 'react';
import { Buttons } from 'components';
import { Filter as FilterIcon } from 'assets/icons';
import { useSignal, useComputed } from '@preact/signals-react';
import { Loader, DropDownWrapper, Each } from 'components';
import { useFloating, flip, offset, shift } from '@floating-ui/react-dom';
import * as S from './FilterBtn.styled';
import { LeftBlock } from './leftBlock/LeftBlock';
import { RightBlock } from './rightBlock/RightBlock';

const btnCustomOpen = {
  color: 'rgb(59, 137, 246)', // primary_500
};

export const FilterBtn = ({ showFilterBtn$, placementList$, countryList$, advertiserList$ }) => {
  const btnRef = useRef(null);
  const filterMenuIsOpen$ = useSignal(false);
  const containerRef = useRef(null);
  const currentFilter$ = useSignal(''); //placement, country or advertiser

  const handleBtnClick = useCallback(() => {
    filterMenuIsOpen$.value = true;
  }, []);

  useEffect(() => {
    if (placementList$.value.size) {
      currentFilter$.value = 'placement';
      return;
    }
    if (countryList$.value.size) {
      currentFilter$.value = 'country';
      return;
    }
    if (advertiserList$.value.size) {
      currentFilter$.value = 'advertiser';
      return;
    }
  }, [placementList$.value.size, countryList$.value.size, advertiserList$.value.size]);

  return (
    <S.BtnBox isShow={showFilterBtn$.value} ref={containerRef}>
      <Buttons.QuaternaryNormal
        id='chooseFiltersBtn'
        ref={btnRef}
        icon={<FilterIcon />}
        isDisabled={!currentFilter$.value}
        onClick={handleBtnClick}
        isPressed={filterMenuIsOpen$.value}
        style={filterMenuIsOpen$.value ? btnCustomOpen : {}}
      >
        Filters
      </Buttons.QuaternaryNormal>
      {useComputed(
        () =>
          filterMenuIsOpen$.value && (
            <DropDownWrapper
              isOpen$={filterMenuIsOpen$}
              width={364}
              targetRef={containerRef}
              style={{
                top: '60px',
                right: '0px',
                padding: 0,
              }}
            >
              {!currentFilter$.value ? (
                <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                  <Loader.Local delay={0} />
                </div>
              ) : (
                <S.ContentBox>
                  <LeftBlock
                    placementList$={placementList$}
                    countryList$={countryList$}
                    advertiserList$={advertiserList$}
                    currentFilter$={currentFilter$}
                  />
                  <RightBlock
                    placementList$={placementList$}
                    countryList$={countryList$}
                    advertiserList$={advertiserList$}
                    currentFilter$={currentFilter$}
                  />
                </S.ContentBox>
              )}
            </DropDownWrapper>
          ),
      )}
    </S.BtnBox>
  );
};
